// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"735992b0","259":"bd7579b5","282":"20a89859","399":"d022e65e","538":"0d086de0","614":"084c75c7","921":"1b99dbf5","983":"7978c587"}[chunkId] + ".chunk.js";
};